import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Container } from "@mui/material";
import Navbar from "../CommonC/SelexSolNavbar";


import {
  Box,
  CircularProgress,
  Typography,
} from "@mui/material";

import NewsletterForm from "./NewsletterForm";
import { baseURL } from "../../Config/config";

function EditNewsLetter() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [newsletter, setNewsletter] = useState({
    subject: "",
    sender_name: "SelexSuite Team",
    content: "",
    status: "draft",
  });

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchNewsletter = async () => {
      try {
        const response = await fetch(
          `${baseURL}/admin/newsletters/${id}`,
          {
            credentials: "include",
          }
        );

        const data = await response.json();

        if (!response.ok || !data.success) {
          throw new Error(
            data.message || "Unable to load newsletter."
          );
        }

        setNewsletter(data.newsletter);
      } catch (err) {
        console.error(err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchNewsletter();
  }, [id]);

  const submit = async () => {
    if (saving) return;

    if (newsletter.status !== "draft") {
      alert("Only draft newsletters can be edited.");
      return;
    }

    if (!newsletter.subject?.trim()) {
      alert("Please enter the newsletter subject.");
      return;
    }

    const plainText = (newsletter.content || "")
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/g, " ")
      .trim();

    if (!plainText) {
      alert("Please enter newsletter content.");
      return;
    }

    try {
      setSaving(true);

      const response = await fetch(
        `${baseURL}/admin/newsletters/${id}`,
        {
          method: "PUT",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            // Add your CSRF header if required.
          },
          body: JSON.stringify({
            subject: newsletter.subject,
            sender_name: newsletter.sender_name,
            content: newsletter.content,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(
          data.message || "Unable to update newsletter."
        );
      }

      alert("Newsletter updated successfully!");
      navigate("/adminhome");
    } catch (err) {
      console.error("Update error:", err);
      alert(err.message);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ textAlign: "center", mt: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Typography color="error" sx={{ p: 4 }}>
        {error}
      </Typography>
    );
  }

  return (
      <div
          style={{
            minHeight: "100vh",
            background: "#f1f5f9",
          }}
        >
          <Navbar admin={true} />
    
          <Container
            maxWidth={false}
            sx={{
              maxWidth: "1250px",
              marginTop: "15px",
              padding: "10px",
              paddingBottom: "40px",
            }}
          >
    <NewsletterForm
      newsletter={newsletter}
      setNewsletter={setNewsletter}
      onSubmit={submit}
      editStatus={true}
      saving={saving}
    />
    </Container>
    </div>
  );
}

export default EditNewsLetter;